<template>
    <h2>Preview content</h2>
    <MasterBlog v-if="slugType == 'post'" :data="dataSinglePost" ></MasterBlog>
    <MasterTemplate v-if="slugType == 'page'&& data_master_template" :data="data_master_template"></MasterTemplate>
    <DefaultTemplate v-if="slugType == 'page'&& dataDefault" :data="dataDefault"></DefaultTemplate>
    <SaleCampaignTemplate v-if="slugType == 'page'&& data_campaign" :data="data_campaign"></SaleCampaignTemplate>
</template>
  
<script setup lang="ts">
    import { ref, onMounted, watch } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    // import MasterBlog from '../components/Blog/MasterBlog.vue';
    // import MasterTemplate from "../components/TemplateMaster/MasterTemplate.vue";
    // import DefaultTemplate from "../components/Page/default.vue";
    // import SaleCampaignTemplate from "../components/Campaign/Sale.vue"
  
    const MasterBlog = defineAsyncComponent(() => import("../components/Blog/MasterBlog.vue"));
    const MasterTemplate = defineAsyncComponent(() => import("../components/TemplateMaster/MasterTemplate.vue"));
    const DefaultTemplate = defineAsyncComponent(() => import("../components/Page/default.vue"));
    const SaleCampaignTemplate = defineAsyncComponent(() => import("../components/Campaign/Sale.vue"));
    const { pushToDataLayer, pushPageTypeToDataLayer } = useCustomGtm();
    const { $file } = useNuxtApp();
    const userStore = useUserStore();
    const dataSinglePost = ref([]);
    const router = useRouter();
    const route = useRoute();
    const data_master_template = ref();
    const data_campaign = ref();
    const dataDefault = ref();
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    let country = '';
    if (locale.value === 'ms-my') {
      country = '/ms-my';
    } else {
      country = '';
    }
    interface IResponseData {
      success: boolean;
      data: string;
      page_template?: string;
    }
  
  definePageMeta({
    middleware: 'page-slug'
  })
  
  const slugType = useState('slugType');
  
  const fetchPosts = async () => {
      try {
        const pageId = route.query.p;
        const previewId = route.query.preview_id
        const preview = route.query.preview;
        const type = route.query.type;
  
        if( slugType.value == 'page' ) {
            let page_file = `pages/${route.params.slug}.json`;
            if(previewId && preview === 'true' && userStore.isLogin && (userStore.user?.role == 'administrator' || userStore.user?.role == 'editor')){
              page_file = `preview/${previewId}-preview.json`;
            }
            const { data: masterTemplate } = await useAsyncData(
                'master-template',
                async () => {
                    return $file.get(page_file, {
                      headers: {
                        Authorization: `Bearer ${userStore.csrf}`,
                        'X-API-Server': userStore.csrf_server
                      },
                    });
                }
            )
  
            const response_Template = masterTemplate.value as IResponseData;
            // console.log('response_Template', response_Template);
            if ( response_Template !== null && response_Template.success) {
              if(response_Template.page_template=='template-master'){
                data_master_template.value = response_Template;
              }else if( response_Template.page_template=='template-sale-campaign'){
                data_campaign.value = response_Template.data;
              }else{
                dataDefault.value = response_Template
              }
            }
        }
  
        if( slugType.value == 'post' ) {
          let file_name = `single-post/${route.params.slug}.json`;
          if(pageId && preview === 'true' && userStore.isLogin && (userStore.user?.role == 'administrator' || userStore.user?.role == 'editor')){
            file_name = `preview/${pageId}-preview.json`;
          }
          const { data: singlePost } = await useAsyncData(
              'singlePost',
              async () => {
                  return $file.get(file_name, {
                      headers: {
                        Authorization: `Bearer ${userStore.csrf}`,
                        'X-API-Server': userStore.csrf_server
                      },
                  });
              }
          )
  
          if (singlePost.value) {
            const postStatus = singlePost.value?.status ?? '';
            const currentPost = singlePost.value;
            if(postStatus == 'private') {
              if(userStore.isLogin && (userStore.user?.role == 'administrator' || userStore.user?.role == 'editor')) {
                dataSinglePost.value = currentPost;
              }else{
                router.push(`${country}/404/`);
              }
            }else if(postStatus == 'publish') {
              dataSinglePost.value = currentPost;
            }
            else{
              router.push(`${country}/404/`);
            }
          }
        }
  
      } catch (e) {
          console.error(e);
      }
  };
  
    watch(() => route.params.slug, () => {
      fetchPosts();
    }, { immediate: true });
  
    onMounted(() => {
      altLazyIO();
    })
</script>